import React from "react";
import PropTypes from "prop-types";

/**
 * The ClozeSure mark, as a single-colour icon.
 *
 * Used on the health board for OUR services (queues, backup, engagement,
 * redirects) so they read as ours rather than as another third party. Takes
 * `currentColor` so it tints to the health state like every other mark.
 */
export default function ClozeSureMark({
  size = 18,
  className = "",
  title = "ClozeSure",
}) {
  return (
    <svg
      viewBox="0 0 144 144"
      width={size}
      height={size}
      className={className}
      role="img"
      aria-label={title}
      fill="currentColor"
    >
      <title>{title}</title>
      <path d="M47.208,100.32c-7.876,-6.902 -12.858,-17.026 -12.858,-28.321c0,-20.792 16.856,-37.648 37.648,-37.648c20.792,0 37.648,16.856 37.648,37.648c0,11.035 -4.747,20.96 -12.311,27.845l11.305,28.489c18.396,-11.99 30.56,-32.74 30.56,-56.334c0,-37.114 -30.087,-67.198 -67.198,-67.198c-37.111,-0 -67.202,30.087 -67.202,67.198c0,23.71 12.279,44.547 30.824,56.508l11.588,-28.186l-0.003,0Z" />
      <path d="M81.544,94.122c8.558,-3.699 14.547,-12.212 14.547,-22.124c0,-13.308 -10.787,-24.095 -24.095,-24.095c-13.308,0 -24.095,10.787 -24.095,24.095c0,10.096 6.214,18.737 15.023,22.323l-15.373,40.273c7.577,2.962 15.817,4.606 24.443,4.606c8.626,0 17.075,-1.685 24.729,-4.718l-15.183,-40.356l0.006,-0.003Z" />
    </svg>
  );
}

ClozeSureMark.propTypes = {
  size: PropTypes.number,
  className: PropTypes.string,
  title: PropTypes.string,
};
